var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.141,10.857c.023.328.023.656.023.984,0,10.008-7.617,21.539-21.539,21.539A21.393,21.393,0,0,1,0,29.982a15.661,15.661,0,0,0,1.828.094,15.161,15.161,0,0,0,9.4-3.234,7.584,7.584,0,0,1-7.078-5.25,9.547,9.547,0,0,0,1.43.117,8.007,8.007,0,0,0,1.992-.258,7.571,7.571,0,0,1-6.07-7.43v-.094a7.624,7.624,0,0,0,3.422.961A7.582,7.582,0,0,1,2.578,4.764a21.518,21.518,0,0,0,15.609,7.922A8.546,8.546,0,0,1,18,10.951a7.578,7.578,0,0,1,13.1-5.18,14.9,14.9,0,0,0,4.8-1.828,7.55,7.55,0,0,1-3.328,4.172,15.176,15.176,0,0,0,4.359-1.172,16.273,16.273,0,0,1-3.8,3.914Z","transform":"translate(0 -3.381)","fill":"#fff"}));
}

Twitter.defaultProps = {"width":"36.937","height":"30","viewBox":"0 0 36.937 30"};

module.exports = Twitter;

Twitter.default = Twitter;
